var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    fill: "none",
    viewBox: "0 0 174 147"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.25 78.792H35.487v-6.468c0-25.872 13.737-39.396 38.92-41.748V0C28.619 1.176 0 29.988 0 74.676V147h65.25zm99.592 0h-29.763v-6.468c0-25.872 13.737-39.396 38.921-41.748V0c-45.789 1.176-74.408 29.988-74.408 74.676V147h65.25z"
  })));
};
export default SvgQuote;